import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import "@/plumbing/maps";
import "@/plumbing/http";
import "@/plumbing/errorHandler";
import "@/validation/rules";
import "@/filters";
import "./global.scss";
import VueMq from "vue-mq";
import FormatToSiteLocalDateTimePlugin from "@/plugins/formatToSiteLocalDateTimePlugin";

Vue.config.productionTip = false;

Vue.use(VueMq, {
  breakpoints: {
    sm: 960,
    md: 1264,
    lg: Infinity
  }
});

Vue.use(FormatToSiteLocalDateTimePlugin);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
